// THIS FILE IS GENERATED — DO NOT EDIT.
// Source: github.com/corp-ais/go-cxa/pkg/permission/catalog/catalog.go
// Regenerate from any CXA service that wires the catalog (e.g.
// cxa-enricher-api or cxa-exposer):
//   make gen:perms-ts
//
// The TypeScript constant names mirror the Go constant names exactly.
// Use these constants in permissionGuard / *hasPermission instead of
// string literals so backend and frontend cannot drift apart.

export const Permissions = {
  AccountCreate: "account:create",
  AccountRead: "account:read",
  AccountUpdate: "account:update",
  AgreementCreate: "agreement:create",
  AgreementRead: "agreement:read",
  AgreementUpdate: "agreement:update",
  AgreementDelete: "agreement:delete",
  AgreementSpecificationCreate: "agreementSpecification:create",
  AgreementSpecificationRead: "agreementSpecification:read",
  AgreementSpecificationUpdate: "agreementSpecification:update",
  AgreementSpecificationDelete: "agreementSpecification:delete",
  AuditLogRead: "auditLog:read",
  EventRecordRead: "eventRecord:read",
  BannerCreate: "banner:create",
  BannerRead: "banner:read",
  BannerUpdate: "banner:update",
  BannerDelete: "banner:delete",
  BannerPublish: "banner:publish",
  BannerReject: "banner:reject",
  CampaignCreate: "campaign:create",
  CampaignRead: "campaign:read",
  CampaignUpdate: "campaign:update",
  CampaignDelete: "campaign:delete",
  CampaignMcCreate: "campaignMc:create",
  CampaignMcRead: "campaignMc:read",
  CampaignMcUpdate: "campaignMc:update",
  CampaignMcDelete: "campaignMc:delete",
  CatalogCreate: "catalog:create",
  CatalogRead: "catalog:read",
  CatalogUpdate: "catalog:update",
  CatalogDelete: "catalog:delete",
  CategoryCreate: "category:create",
  CategoryRead: "category:read",
  CategoryUpdate: "category:update",
  CategoryDelete: "category:delete",
  ConditionTemplateCreate: "conditionTemplate:create",
  ConditionTemplateRead: "conditionTemplate:read",
  ConditionTemplateUpdate: "conditionTemplate:update",
  ConditionTemplateDelete: "conditionTemplate:delete",
  ConditionTemplatePublish: "conditionTemplate:publish",
  BlobCreate: "blob:create",
  BlobRead: "blob:read",
  BlobUpdate: "blob:update",
  BlobDelete: "blob:delete",
  BlobContainerCreate: "blobContainer:create",
  BlobContainerDelete: "blobContainer:delete",
  BlobPrivateCreate: "blobPrivate:create",
  BlobPrivateRead: "blobPrivate:read",
  BlobPrivateUpdate: "blobPrivate:update",
  BlobPrivateDelete: "blobPrivate:delete",
  BlobPrivateContainerCreate: "blobPrivateContainer:create",
  BlobPrivateContainerDelete: "blobPrivateContainer:delete",
  InternetRoamingCreate: "internetRoaming:create",
  InternetRoamingDelete: "internetRoaming:delete",
  InternetRoamingRead: "internetRoaming:read",
  InternetRoamingUpdate: "internetRoaming:update",
  InternetRoamingImport: "internetRoaming:import",
  InternetRoamingExport: "internetRoaming:export",
  ConfigChannelCreate: "config:channel:create",
  ConfigChannelRead: "config:channel:read",
  ConfigChannelUpdate: "config:channel:update",
  ConfigChannelDelete: "config:channel:delete",
  ConfigResourceCreate: "config:resource:create",
  ConfigResourceRead: "config:resource:read",
  ConfigResourceUpdate: "config:resource:update",
  ConfigResourceDelete: "config:resource:delete",
  ConfigPermissionCreate: "config:permission:create",
  ConfigPermissionRead: "config:permission:read",
  ConfigPermissionUpdate: "config:permission:update",
  ConfigPermissionDelete: "config:permission:delete",
  ConfigScopeCreate: "config:scope:create",
  ConfigScopeRead: "config:scope:read",
  ConfigScopeUpdate: "config:scope:update",
  ConfigScopeDelete: "config:scope:delete",
  ConfigPositionCreate: "config:position:create",
  ConfigPositionRead: "config:position:read",
  ConfigPositionUpdate: "config:position:update",
  ConfigPositionDelete: "config:position:delete",
  ConfigNTypeCreate: "config:nType:create",
  ConfigNTypeRead: "config:nType:read",
  ConfigNTypeUpdate: "config:nType:update",
  ConfigNTypeDelete: "config:nType:delete",
  ConfigLanguageCreate: "config:language:create",
  ConfigLanguageRead: "config:language:read",
  ConfigLanguageUpdate: "config:language:update",
  ConfigLanguageDelete: "config:language:delete",
  ConfigBannerCreate: "config:banner:create",
  ConfigBannerRead: "config:banner:read",
  ConfigBannerUpdate: "config:banner:update",
  ConfigBannerDelete: "config:banner:delete",
  ConfigPersonaCreate: "config:persona:create",
  ConfigPersonaRead: "config:persona:read",
  ConfigPersonaUpdate: "config:persona:update",
  ConfigPersonaDelete: "config:persona:delete",
  ChannelProductLineCreate: "channelProductLine:create",
  ChannelProductLineRead: "channelProductLine:read",
  ChannelProductLineUpdate: "channelProductLine:update",
  ChannelProductLineDelete: "channelProductLine:delete",
  ChildSyncRead: "childSync:read",
  ChildSyncApply: "childSync:apply",
  ChildSyncConfig: "childSync:config",
  AutoEnrichConfig: "autoEnrich:config",
  AllChannelRuleConfig: "allChannelRule:config",
  AutoEnrichRuleConfig: "autoEnrichRule:config",
  EasyAppPackageRead: "easyApp:package:read",
  EasyAppPackageUpdate: "easyApp:package:update",
  EasyAppPackageImport: "easyApp:package:import",
  EasyAppPackageExport: "easyApp:package:export",
  EasyAppPackageDuplicate: "easyApp:package:duplicate",
  EffectiveCreate: "effective:create",
  EffectiveRead: "effective:read",
  EffectiveUpdate: "effective:update",
  EffectiveDelete: "effective:delete",
  EnrichmentRead: "enrichment:read",
  EnrichmentUpdate: "enrichment:update",
  EnrichmentChannelScopeUpdate: "enrichment:channelScope:update",
  EnrichmentPublish: "enrichment:publish",
  EnrichmentReject: "enrichment:reject",
  EnrichmentImport: "enrichment:import",
  EnrichmentExport: "enrichment:export",
  EntitlementRead: "entitlement:read",
  EntitlementUpdate: "entitlement:update",
  FeatureFlagRead: "featureFlag:read",
  FeatureFlagUpdate: "featureFlag:update",
  FileShareCreate: "fileShare:create",
  FileShareRead: "fileShare:read",
  FileShareUpdate: "fileShare:update",
  FileShareDelete: "fileShare:delete",
  FileShareContainerCreate: "fileShareContainer:create",
  FileShareContainerDelete: "fileShareContainer:delete",
  LifeStyleCreate: "lifeStyle:create",
  LifeStyleRead: "lifeStyle:read",
  LifeStyleUpdate: "lifeStyle:update",
  LifeStyleDelete: "lifeStyle:delete",
  MailConfigCreate: "mailConfig:create",
  MailConfigRead: "mailConfig:read",
  MailConfigUpdate: "mailConfig:update",
  MailConfigDelete: "mailConfig:delete",
  MasterCatalogTypeRead: "masterCatalogType:read",
  MasterChannelRead: "masterChannel:read",
  MasterEffectiveRead: "masterEffective:read",
  MasterLanguageRead: "masterLanguage:read",
  MasterNTypeRead: "masterNType:read",
  MasterPersonaRead: "masterPersona:read",
  MasterPositionRead: "masterPosition:read",
  MasterSegmentRead: "masterSegment:read",
  MasterBlobCreate: "masterBlob:create",
  MasterBlobRead: "masterBlob:read",
  MasterBlobUpdate: "masterBlob:update",
  MasterBlobDelete: "masterBlob:delete",
  OAuth2ClientCreate: "oauth2Client:create",
  OAuth2ClientRead: "oauth2Client:read",
  OAuth2ClientUpdate: "oauth2Client:update",
  OAuth2ClientDelete: "oauth2Client:delete",
  OnlineStoreRead: "onlineStore:read",
  OnlineStoreUpdate: "onlineStore:update",
  OnlineStoreDelete: "onlineStore:delete",
  OnlineStoreCreate: "onlineStore:create",
  OnlineStorePublish: "onlineStore:publish",
  OnlineStoreReject: "onlineStore:reject",
  OnlineStoreImport: "onlineStore:import",
  OnlineStoreExport: "onlineStore:export",
  PolicyCreate: "policy:create",
  PolicyRead: "policy:read",
  PolicyUpdate: "policy:update",
  PolicyDelete: "policy:delete",
  ProductOfferingCreate: "productOffering:create",
  ProductOfferingRead: "productOffering:read",
  ProductOfferingUpdate: "productOffering:update",
  ProductOfferingDelete: "productOffering:delete",
  ModelProductGroupCreate: "modelProductGroup:create",
  ModelProductGroupRead: "modelProductGroup:read",
  ModelProductGroupUpdate: "modelProductGroup:update",
  ProductOfferingPriceCreate: "productOfferingPrice:create",
  ProductOfferingPriceRead: "productOfferingPrice:read",
  ProductOfferingPriceUpdate: "productOfferingPrice:update",
  ProductOfferingPriceDelete: "productOfferingPrice:delete",
  ProductSpecificationCreate: "productSpecification:create",
  ProductSpecificationRead: "productSpecification:read",
  ProductSpecificationUpdate: "productSpecification:update",
  ProductSpecificationDelete: "productSpecification:delete",
  RedisCreate: "redis:create",
  RedisRead: "redis:read",
  RedisUpdate: "redis:update",
  RedisDelete: "redis:delete",
  RoleCreate: "role:create",
  RoleRead: "role:read",
  RoleUpdate: "role:update",
  RoleDelete: "role:delete",
  PromotionByLocationCreate: "promotion:byLocation:create",
  PromotionByLocationRead: "promotion:byLocation:read",
  PromotionByLocationUpdate: "promotion:byLocation:update",
  PromotionByLocationDelete: "promotion:byLocation:delete",
  PromotionByLocationImport: "promotion:byLocation:import",
  PromotionByLocationExport: "promotion:byLocation:export",
  RomPackageRead: "romPackage:read",
  RomPackageUpdate: "romPackage:update",
  UserRead: "user:read",
  UserCustomizationCreate: "userCustomization:create",
  UserCustomizationRead: "userCustomization:read",
  UserCustomizationUpdate: "userCustomization:update",
  USSDCreate: "ussd:create",
  USSDRead: "ussd:read",
  USSDUpdate: "ussd:update",
  USSDDelete: "ussd:delete",
  ImageManagementCreate: "imageManagement:create",
  ImageManagementRead: "imageManagement:read",
  ImageManagementUpdate: "imageManagement:update",
  ImageManagementDelete: "imageManagement:delete",
  InstallmentManagementCreate: "installmentManagement:create",
  InstallmentManagementRead: "installmentManagement:read",
  InstallmentManagementUpdate: "installmentManagement:update",
  InstallmentManagementDelete: "installmentManagement:delete",
  VdoPackageRead: "vdoPackage:read",
  VdoPackageUpdate: "vdoPackage:update",
  VdoCampaignCreate: "vdoCampaign:create",
  VdoCampaignRead: "vdoCampaign:read",
  VdoCampaignUpdate: "vdoCampaign:update",
  VdoCampaignDelete: "vdoCampaign:delete",
  MyChannelPackageMainCreate: "myChannel:packageMain:create",
  MyChannelPackageMainRead: "myChannel:packageMain:read",
  MyChannelPackageMainUpdate: "myChannel:packageMain:update",
  MyChannelPackageMainDelete: "myChannel:packageMain:delete",
  MyChannelPackageMainImport: "myChannel:packageMain:import",
  MyChannelPackageMainExport: "myChannel:packageMain:export",
  MyChannelOrderTypeCreate: "myChannel:orderType:create",
  MyChannelOrderTypeRead: "myChannel:orderType:read",
  MyChannelOrderTypeUpdate: "myChannel:orderType:update",
  MyChannelOrderTypeDelete: "myChannel:orderType:delete",
} as const;

export type Permission = (typeof Permissions)[keyof typeof Permissions];

/** Every permission identity defined in the backend catalog. */
export const ALL_PERMISSIONS: readonly Permission[] = [
  Permissions.AccountCreate,
  Permissions.AccountRead,
  Permissions.AccountUpdate,
  Permissions.AgreementCreate,
  Permissions.AgreementRead,
  Permissions.AgreementUpdate,
  Permissions.AgreementDelete,
  Permissions.AgreementSpecificationCreate,
  Permissions.AgreementSpecificationRead,
  Permissions.AgreementSpecificationUpdate,
  Permissions.AgreementSpecificationDelete,
  Permissions.AuditLogRead,
  Permissions.EventRecordRead,
  Permissions.BannerCreate,
  Permissions.BannerRead,
  Permissions.BannerUpdate,
  Permissions.BannerDelete,
  Permissions.BannerPublish,
  Permissions.BannerReject,
  Permissions.CampaignCreate,
  Permissions.CampaignRead,
  Permissions.CampaignUpdate,
  Permissions.CampaignDelete,
  Permissions.CampaignMcCreate,
  Permissions.CampaignMcRead,
  Permissions.CampaignMcUpdate,
  Permissions.CampaignMcDelete,
  Permissions.CatalogCreate,
  Permissions.CatalogRead,
  Permissions.CatalogUpdate,
  Permissions.CatalogDelete,
  Permissions.CategoryCreate,
  Permissions.CategoryRead,
  Permissions.CategoryUpdate,
  Permissions.CategoryDelete,
  Permissions.ConditionTemplateCreate,
  Permissions.ConditionTemplateRead,
  Permissions.ConditionTemplateUpdate,
  Permissions.ConditionTemplateDelete,
  Permissions.ConditionTemplatePublish,
  Permissions.BlobCreate,
  Permissions.BlobRead,
  Permissions.BlobUpdate,
  Permissions.BlobDelete,
  Permissions.BlobContainerCreate,
  Permissions.BlobContainerDelete,
  Permissions.BlobPrivateCreate,
  Permissions.BlobPrivateRead,
  Permissions.BlobPrivateUpdate,
  Permissions.BlobPrivateDelete,
  Permissions.BlobPrivateContainerCreate,
  Permissions.BlobPrivateContainerDelete,
  Permissions.InternetRoamingCreate,
  Permissions.InternetRoamingDelete,
  Permissions.InternetRoamingRead,
  Permissions.InternetRoamingUpdate,
  Permissions.InternetRoamingImport,
  Permissions.InternetRoamingExport,
  Permissions.ConfigChannelCreate,
  Permissions.ConfigChannelRead,
  Permissions.ConfigChannelUpdate,
  Permissions.ConfigChannelDelete,
  Permissions.ConfigResourceCreate,
  Permissions.ConfigResourceRead,
  Permissions.ConfigResourceUpdate,
  Permissions.ConfigResourceDelete,
  Permissions.ConfigPermissionCreate,
  Permissions.ConfigPermissionRead,
  Permissions.ConfigPermissionUpdate,
  Permissions.ConfigPermissionDelete,
  Permissions.ConfigScopeCreate,
  Permissions.ConfigScopeRead,
  Permissions.ConfigScopeUpdate,
  Permissions.ConfigScopeDelete,
  Permissions.ConfigPositionCreate,
  Permissions.ConfigPositionRead,
  Permissions.ConfigPositionUpdate,
  Permissions.ConfigPositionDelete,
  Permissions.ConfigNTypeCreate,
  Permissions.ConfigNTypeRead,
  Permissions.ConfigNTypeUpdate,
  Permissions.ConfigNTypeDelete,
  Permissions.ConfigLanguageCreate,
  Permissions.ConfigLanguageRead,
  Permissions.ConfigLanguageUpdate,
  Permissions.ConfigLanguageDelete,
  Permissions.ConfigBannerCreate,
  Permissions.ConfigBannerRead,
  Permissions.ConfigBannerUpdate,
  Permissions.ConfigBannerDelete,
  Permissions.ConfigPersonaCreate,
  Permissions.ConfigPersonaRead,
  Permissions.ConfigPersonaUpdate,
  Permissions.ConfigPersonaDelete,
  Permissions.ChannelProductLineCreate,
  Permissions.ChannelProductLineRead,
  Permissions.ChannelProductLineUpdate,
  Permissions.ChannelProductLineDelete,
  Permissions.ChildSyncRead,
  Permissions.ChildSyncApply,
  Permissions.ChildSyncConfig,
  Permissions.AutoEnrichConfig,
  Permissions.AllChannelRuleConfig,
  Permissions.AutoEnrichRuleConfig,
  Permissions.EasyAppPackageRead,
  Permissions.EasyAppPackageUpdate,
  Permissions.EasyAppPackageImport,
  Permissions.EasyAppPackageExport,
  Permissions.EasyAppPackageDuplicate,
  Permissions.EffectiveCreate,
  Permissions.EffectiveRead,
  Permissions.EffectiveUpdate,
  Permissions.EffectiveDelete,
  Permissions.EnrichmentRead,
  Permissions.EnrichmentUpdate,
  Permissions.EnrichmentChannelScopeUpdate,
  Permissions.EnrichmentPublish,
  Permissions.EnrichmentReject,
  Permissions.EnrichmentImport,
  Permissions.EnrichmentExport,
  Permissions.EntitlementRead,
  Permissions.EntitlementUpdate,
  Permissions.FeatureFlagRead,
  Permissions.FeatureFlagUpdate,
  Permissions.FileShareCreate,
  Permissions.FileShareRead,
  Permissions.FileShareUpdate,
  Permissions.FileShareDelete,
  Permissions.FileShareContainerCreate,
  Permissions.FileShareContainerDelete,
  Permissions.LifeStyleCreate,
  Permissions.LifeStyleRead,
  Permissions.LifeStyleUpdate,
  Permissions.LifeStyleDelete,
  Permissions.MailConfigCreate,
  Permissions.MailConfigRead,
  Permissions.MailConfigUpdate,
  Permissions.MailConfigDelete,
  Permissions.MasterCatalogTypeRead,
  Permissions.MasterChannelRead,
  Permissions.MasterEffectiveRead,
  Permissions.MasterLanguageRead,
  Permissions.MasterNTypeRead,
  Permissions.MasterPersonaRead,
  Permissions.MasterPositionRead,
  Permissions.MasterSegmentRead,
  Permissions.MasterBlobCreate,
  Permissions.MasterBlobRead,
  Permissions.MasterBlobUpdate,
  Permissions.MasterBlobDelete,
  Permissions.OAuth2ClientCreate,
  Permissions.OAuth2ClientRead,
  Permissions.OAuth2ClientUpdate,
  Permissions.OAuth2ClientDelete,
  Permissions.OnlineStoreRead,
  Permissions.OnlineStoreUpdate,
  Permissions.OnlineStoreDelete,
  Permissions.OnlineStoreCreate,
  Permissions.OnlineStorePublish,
  Permissions.OnlineStoreReject,
  Permissions.OnlineStoreImport,
  Permissions.OnlineStoreExport,
  Permissions.PolicyCreate,
  Permissions.PolicyRead,
  Permissions.PolicyUpdate,
  Permissions.PolicyDelete,
  Permissions.ProductOfferingCreate,
  Permissions.ProductOfferingRead,
  Permissions.ProductOfferingUpdate,
  Permissions.ProductOfferingDelete,
  Permissions.ModelProductGroupCreate,
  Permissions.ModelProductGroupRead,
  Permissions.ModelProductGroupUpdate,
  Permissions.ProductOfferingPriceCreate,
  Permissions.ProductOfferingPriceRead,
  Permissions.ProductOfferingPriceUpdate,
  Permissions.ProductOfferingPriceDelete,
  Permissions.ProductSpecificationCreate,
  Permissions.ProductSpecificationRead,
  Permissions.ProductSpecificationUpdate,
  Permissions.ProductSpecificationDelete,
  Permissions.RedisCreate,
  Permissions.RedisRead,
  Permissions.RedisUpdate,
  Permissions.RedisDelete,
  Permissions.RoleCreate,
  Permissions.RoleRead,
  Permissions.RoleUpdate,
  Permissions.RoleDelete,
  Permissions.PromotionByLocationCreate,
  Permissions.PromotionByLocationRead,
  Permissions.PromotionByLocationUpdate,
  Permissions.PromotionByLocationDelete,
  Permissions.PromotionByLocationImport,
  Permissions.PromotionByLocationExport,
  Permissions.RomPackageRead,
  Permissions.RomPackageUpdate,
  Permissions.UserRead,
  Permissions.UserCustomizationCreate,
  Permissions.UserCustomizationRead,
  Permissions.UserCustomizationUpdate,
  Permissions.USSDCreate,
  Permissions.USSDRead,
  Permissions.USSDUpdate,
  Permissions.USSDDelete,
  Permissions.ImageManagementCreate,
  Permissions.ImageManagementRead,
  Permissions.ImageManagementUpdate,
  Permissions.ImageManagementDelete,
  Permissions.InstallmentManagementCreate,
  Permissions.InstallmentManagementRead,
  Permissions.InstallmentManagementUpdate,
  Permissions.InstallmentManagementDelete,
  Permissions.VdoPackageRead,
  Permissions.VdoPackageUpdate,
  Permissions.VdoCampaignCreate,
  Permissions.VdoCampaignRead,
  Permissions.VdoCampaignUpdate,
  Permissions.VdoCampaignDelete,
  Permissions.MyChannelPackageMainCreate,
  Permissions.MyChannelPackageMainRead,
  Permissions.MyChannelPackageMainUpdate,
  Permissions.MyChannelPackageMainDelete,
  Permissions.MyChannelPackageMainImport,
  Permissions.MyChannelPackageMainExport,
  Permissions.MyChannelOrderTypeCreate,
  Permissions.MyChannelOrderTypeRead,
  Permissions.MyChannelOrderTypeUpdate,
  Permissions.MyChannelOrderTypeDelete,
] as const;
